import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { AddressDto } from "./address.dto";
import { CreateAddressDto } from "./create-address.dto";
import { UpdateAddressDto } from "./update-address.dto";
import { OptionType } from "@/types/OptionType";
import { getOptionLoader } from "@/core/common/presenters/optionLoader";
import { IFilterModel } from "@/interfaces/IFilterModel";

export class AddressesResource extends ResourceBaseService<AddressDto, CreateAddressDto, UpdateAddressDto> {
  protected EntityDto = AddressDto;
  protected CreateEntityDto = CreateAddressDto;
  protected UpdateEntityDto = UpdateAddressDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/addresses");
  }

  async optionLoader(inputValue: string, filters?: IFilterModel): Promise<OptionType[]> {
    return getOptionLoader(
      inputValue,
      ["id", "name"],
      [{ field: "name", order: "ASC" }],
      (request) => this.findAll(request),
      ["name"],
      filters
    );
  }
}
